import React from 'react'

export const Person = ({ name, position, descr }) => {
	return (
		<div className="person">
			<div className="person_heading">
				<h3 className="person_name">{name}</h3>
				<span className="person_subtitle">{position}</span>
			</div>
			<div className="person_descr">{descr}</div>
		</div>
	);
}
export default Person;